import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortfolioMobileFooterComponent } from './components/portfolio-mobile-footer/portfolio-mobile-footer.component';

@NgModule({
  declarations: [PortfolioMobileFooterComponent],
  imports: [
    CommonModule
  ],
  exports: [PortfolioMobileFooterComponent]
})
export class PortfolioMobileFooterModule { }
